<template>
  <div class="right-drawer">
    <v-list>
      <v-list-item>
        <v-text-field
          class="no-before"
          :value="getUserName"
          prepend-icon="person"
          label="User"
          readonly
        ></v-text-field>
      </v-list-item>
      <v-list-item>
        <v-select
          class="no-before"
          v-model="organisationId"
          :items="getOrganisationsAvailables"
          item-text="name_organisation"
          item-value="id_organisation"
          prepend-icon="home"
          label="Organisation"
          readonly
          disabled
        ></v-select>
      </v-list-item>
      <v-list-item>
        <v-select
          class="no-before"
          v-model="storeId"
          :items="
            getAvailablesStores.filter(x => x.organisation === organisationId)
          "
          item-text="name_store"
          item-value="id_store"
          prepend-icon="store_mall_directory"
          label="Succursale"
          readonly
          disabled
        ></v-select>
      </v-list-item>
    </v-list>
    <div style="width: 100%">
      <UserSettingsEditor v-if="getIsAdmin"></UserSettingsEditor>
      <v-list dense style="width: 100%">
        <v-list-group no-action sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Personnalisations</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item style="width: 100%">
            <v-list-item-action style="width: 100%">
              <div class="dark-control">
                <v-switch
                  prepend-icon="fa-sun"
                  v-model="darkTheme"
                  append-icon="fa-moon"
                ></v-switch>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-list-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserSettingsEditor from "./UserSettingsEditor";
export default {
  name: "UserSettingsList",
  components: {
    UserSettingsEditor
  },
  computed: {
    ...mapGetters([
      "getOrganisationsAvailables",
      "getAvailablesStores",
      "getUserName",
      "getIsAdmin"
    ]),
    organisationId: {
      get() {
        return this.$store.getters.getOrganisationId;
      },
      set(v) {
        this.$store.dispatch("setOrganisation", v);
        this.$store.dispatch(
          "setStore",
          this.getStoresAvailables.filter(x => x.organisation === v)[0].id_store
        );
      }
    },
    storeId: {
      get() {
        return this.$store.getters.getStoreId;
      },
      set(v) {
        this.$store.dispatch("setStore", v);
      }
    },
    darkTheme: {
      get() {
        return this.$store.getters.isDark;
      },
      set() {
        this.$store.dispatch("toggleDarkTheme");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.right-drawer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 1rem 0;
  .dark-control {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    .dark-control-icon {
      height: 20px;
      width: 20px;
      opacity: 0.54;
    }
    .sun {
      margin-right: 0.6rem;
    }
  }
  .theme--dark {
    .dark-control {
      .dark-control-icon {
        opacity: 1;
      }
    }
  }
}
</style>
